// Called by : src/components/lesson/SkillItem.vue (course-item)

<template>
  <vsa-item :force-active="course.open" :on-heading-click="onHeadingClick">

    {{ forceUpdate }}

    <vsa-heading>
      <span v-if="course.trainer" class="vsa_span vsa_trainer ui_tip vsa_right d-none d-md-inline" v-bind:title="courseTrainer">
        <span class="oi oi-person pr-2" style="font-size:1rem;"></span>
        <span class="">{{ course.trainer }}</span>
      </span>

      <span class="vsa_title_cont">
        <span class="vsa_span vsa_label vsa_label_course d-none d-md-inline">{{ courseName }}</span>
        <span class="vsa_span vsa_title vsa_title_course">{{ course.title }}</span>
      </span>

      <span v-if="course.trainer" class="vsa_span vsa_trainer ui_tip mt-2 d-block d-md-none" v-bind:title="courseTrainer">
        <span class="oi oi-person pr-2" style="font-size:1rem;"></span>
        <span class="">{{ course.trainer }}</span>
      </span>
    </vsa-heading>

    <vsa-content>
      <vsa-list :auto-collapse="false" :key="componentKey">
        <lesson-item v-for="lesson in course.lessons" :key="lesson.id" :lesson="lesson" />
      </vsa-list>
    </vsa-content>

  </vsa-item>
</template>

<script>
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent,
  VsaIcon
} from 'vue-simple-accordion'
import 'vue-simple-accordion/dist/vue-simple-accordion.css'
import LessonItem from './LessonItem.vue'

export default {
  name: 'course-item',
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
    LessonItem,
  },
  props: {
      course: Object
  },
  data() {
    return {
      componentKey: 0,
      courseName: '',
      courseTrainer: '',
    }
  },
  methods: {
    onHeadingClick() {
      this.course.open = !this.course.open
    },
  },
  computed: {
    forceUpdate() {
      this.componentKey++
      this.courseName = this.$t("assignments.courseName")
      this.courseTrainer = this.$t("assignments.courseTrainer")
      $('.vsa_label_course').text(this.courseName);
      $('.vsa_trainer').attr('title', this.courseTrainer);
      return '';
    },
  }
}
</script>

<style scoped>
  /* void */
</style>



// WEBPACK FOOTER //
// src/components/lesson/CourseItem.vue